export const INDIVIDUAL = 'INDIVIDUAL';
export const GROUP = 'GROUP';
export const QA = 'QA';
export const INTERACTIVE_VIDEO = 'INTERACTIVE_VIDEO';
